module.exports = __webpack_public_path__ + "img/icon-03.a6ba6a57.png";